import { useEffect } from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";
import useUiVisibility from "../../hooks/ui/useUiVisibility";
import UiVisibilityGrid from "../../components/ui/UiVisibilityGrid";

/**
 * 🎨 Página de Configuración de Interfaz de Usuario (UI)
 * Permite mostrar u ocultar dinámicamente los componentes visuales del sistema.
 * Se conecta al backend mediante el hook `useUiVisibility`.
 */
const UiConfiguration = () => {
  const {
    settings,
    loading,
    error,
    fetchUiSettings,
    toggleUiVisibility,
  } = useUiVisibility();

  // 🚀 Cargar configuraciones al montar el componente
  useEffect(() => {
    fetchUiSettings();
  }, []);

  // 🔄 Alternar visibilidad (al presionar el switch)
  const handleToggle = (id: number) => {
    const item = settings.find((s) => s.id === id);
    if (item) {
      toggleUiVisibility(item.code, item.visible);
    }
  };

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <div className="py-6 px-6">
          {/* 🔹 Título principal */}
          <h2 className="mb-4 text-xl font-semibold text-gray-800 dark:text-white">
            Configuración de Interfaz
          </h2>

          {/* 🔸 Descripción */}
          <p className="mb-6 text-gray-600 dark:text-gray-400">
            Activa o desactiva los componentes visuales del sistema según tus
            preferencias o perfil de usuario.
          </p>

          {/* ⏳ Estado de carga */}
          {loading && (
            <p className="text-center text-gray-500 dark:text-gray-400">
              Cargando configuraciones...
            </p>
          )}

          {/* ⚠️ Error */}
          {error && !loading && (
            <p className="text-center text-[#DC3545] font-medium">
              {error}
            </p>
          )}

          {/* 📋 Lista de configuraciones */}
          {!loading && !error && settings.length > 0 && (
            <UiVisibilityGrid items={settings} onToggle={handleToggle} />
          )}

          {/* 💤 Vacío */}
          {!loading && !error && settings.length === 0 && (
            <p className="text-center text-gray-500 dark:text-gray-400">
              No hay configuraciones disponibles.
            </p>
          )}
        </div>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default UiConfiguration;
